import React, { useEffect, useState } from 'react';
import ForgetPasswordForm from 'components/authentication/forgetPasswordForm';
import { fetchLoginImage } from 'assets/js/common';
import AuthSplitLayout from 'layouts/authSplitLayout';
import { useTranslation } from 'react-i18next';
import { Spinner } from 'react-bootstrap';
import LanguageButtons from 'components/navbar/top/languageBtn';

const ForgetPassword = () => {
  const { t } = useTranslation();
  const [bgImg, setBgImg] = useState(null);
  const [isLoading, setIsLoading] = useState(true);

  useEffect(() => {
    const loadImage = async () => {
      const domainToUse = process.env.REACT_APP_DEFAULT_DOMAIN;
      const cacheKey = `cachedLoginBg_${domainToUse}`;

      const cached = localStorage.getItem(cacheKey);
      if (cached) {
        setBgImg(cached);
        setIsLoading(false);
        return;
      }

      const image = await fetchLoginImage();
      localStorage.setItem(cacheKey, image);
      setBgImg(image);
      setIsLoading(false);
    };

    loadImage();
  }, []);

  if (isLoading) {
    return (
      <div className="text-center my-5">
        <span>{t('loading')}</span>
        <Spinner animation="border" role="status" />
      </div>
    );
  }

  return (
    <>
      <div className="language-buttons">
        <LanguageButtons />
      </div>
      <AuthSplitLayout
        bgProps={{ image: bgImg, position: '50% 76%', overlay: false }}
      >
        <div className="text-center">
          <h4 className="mb-0">{t('forgotPasswordTitle')}</h4>
          <small>{t('forgotPasswordDescription')}</small>
          <ForgetPasswordForm layout="split" />
        </div>
      </AuthSplitLayout>
    </>
  );
};

export default ForgetPassword;
